import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ICatalogs, ISupplierAccounts, IVendorSearch } from '../../products/interfaces/suppliers interfaces/supplier-responces.interface';
import { makeQueryParams } from 'projects/admin/src/app/shared/helpers/makeQueryParams';
import { firstValueFrom, noop, Subscription, tap } from 'rxjs';
import { generateGuid } from 'projects/shared/helpers/GUID-generator';
import { ProductsService } from 'projects/shared/services/products.service';
import { OnlyNumbers } from 'projects/shared/validations/onlyNumbers';
import { ToastService } from 'projects/admin/src/app/shared/helpers/toast.service';
import { IProduct } from 'projects/shared/models/product';
import { PaginatorModule } from 'primeng/paginator';
import { ConfirmModal } from 'projects/shared/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-supplier-order',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DropdownModule, DialogModule, PaginatorModule, ConfirmModal, FormsModule],
  templateUrl: './supplier-order.component.html',
  styleUrl: './supplier-order.component.scss'
})
export class SupplierOrderComponent implements OnInit, OnChanges, OnDestroy {


  @Input() product!: any;
  @Input() productId!: string;
  @Output() onAddSku: EventEmitter<any> = new EventEmitter();

  suppliers: any;
  suppliersModal = false;
  supplierId = 0;
  suppliersSKU: any[] = [];
  skuForm!: FormGroup;
  addingSku = false;
  deleteSkuModal = false;
  selectedSkuToDelete: any;
  vendorsSearchResult!: IVendorSearch;
  taping = {
    globalSearch: true,
    catalogs: false,
    order: false
  }
  suppliersTaping = {
    bamboo: true,
    likeCard: false,
    wupex: false
  }
  formSupplierOrder!: FormGroup;
  catalogsList!: ICatalogs;
  page: any = 1;
  limit = 20;
  first = 20;
  total = 0;

  accounts: ISupplierAccounts[] = [];
  selectedAccount!: ISupplierAccounts;
  GUIDChange = true;
  addSkuModal = false;
  productSku = '';
  supplierLoader = false;



  private _subscription = new Subscription();
  constructor(
    private _productsService: ProductsService,
    private _formBuilder: FormBuilder,
    private _toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.initAddSkuForm();
    this.getSuppliers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes: ', changes);
    
  }


  initAddSkuForm() {
    this.skuForm = this._formBuilder.group({
      searchKey: [null, [Validators.required]],
      code: [null, [Validators.required]],
      supplier: [null, [Validators.required]],
    })
  }

  // ? Validations
  onlyNumbers = (event: any) => OnlyNumbers(event)

  getSuppliers() {
    this._subscription.add(
      this._productsService.getVendorsList().pipe(
        tap(
          res => {
            this.suppliers = res;
          })
      ).subscribe(noop)
    )
  }
  getAccounts(vendor: string) {
    if (vendor == 'bamboo') {
      this._productsService.vendorAccounts(vendor).pipe(
        tap(
          res => {
            this.accounts = res;
          }
        )
      ).subscribe(noop)
    }
  }

  onVendorSelect(event: any) {
    console.log('event: ', event);
    if (event.value) {
      let { endpoint } = event.value!;
      let queries: any = {
        page: this.page,
        limit: this.limit,
      }
      if (this.skuForm.get('searchKey')?.value) queries.query = this.skuForm.get('searchKey')?.value;
      if (this.skuForm.get('code')?.value) queries.productId = this.skuForm.get('code')?.value;
      let params = makeQueryParams(queries)

      this.supplierLoader = true;
      this._productsService.getVendorCatalogs(endpoint.substring(1), `?${params}`).pipe(
        tap(
          res => {
            this.supplierLoader = false;
            console.log('res: ', res);
            this.catalogsList = res;
            this.total = res.pagination.total
          }
        )
      ).subscribe(noop, err => {
        this.supplierLoader = false;
        this._toastService.toastData.next({ severity: 'error', summary: 'Error', detail: err.message })
      })
    }
  }


  vendorsSearch(data: ({ code: string, searchKey: string })) {
    let queries: any = {
      query: data.searchKey ? data.searchKey : ''
    }
    if (data.code) queries.productId = data.code;

    const params = makeQueryParams(queries);
    this.supplierLoader = true;

    this._productsService.vendorsSearch(params).pipe(
      tap(
        res => {
          this.supplierLoader = false;
          this.vendorsSearchResult = res;
        }
      )
    ).subscribe(noop, err => {
      this.supplierLoader = false;
      this._toastService.toastData.next({ severity: 'error', summary: 'Error', detail: err.message.error })
    });
  }

  addSupplierSku(item: any) {
    console.log('item: ', item);
    this.addingSku = true;
    console.log('this.product: ', this.product);
    this.product.supplierSkus![item.vendor?.name] = item.id
    
    console.log('this.product: ', this.product);
    this._subscription.add(
      this._productsService.updateProduct(this.product).pipe(
        tap(
          res => {
            this.suppliersSKU = [];
            this.suppliersModal = false;
            this.addingSku = false;
            this._toastService.toastData.next({
              severity: 'success',
              summary: 'Success',
              detail: 'Supplier sku added successfully',
            });
            this.onAddSku.emit(this.product);
          }
        )
      ).subscribe(noop, err => {
        this.supplierLoader = false;
        this._toastService.toastData.next({ severity: 'error', summary: 'Error', detail: err.message.error })
      })
    )
  }

  generateGuid = () => generateGuid();

  createSupplierOrderForm(key: string) {
    if (key == 'bamboo') {
      this.formSupplierOrder = this._formBuilder.group({
        RequestId: [this.generateGuid(), [Validators.required]],
        internalProductId: [this.productId, [Validators.required]],
        AccountId: [this.selectedAccount?.id, [Validators.required]],
        products: this._formBuilder.array([
          this._formBuilder.group({
            ProductId: ['', [Validators.required]],
            Quantity: [null, [Validators.required]],
            Value: ['', [Validators.required]]
          })
        ])
      });

    } else if (key.toLowerCase() == 'likecard') {
      this.formSupplierOrder = this._formBuilder.group({
        internalProductId: ["", [Validators.required]],
        productId: ["", [Validators.required]],
        referenceId: [this.generateGuid(), [Validators.required]],
        quantity: [null, [Validators.required]]
      });
    } else if (key == 'wupex') {
      this.formSupplierOrder = this._formBuilder.group({
        internalProductId: [this.productId, [Validators.required]],
        products: this._formBuilder.array([
          this._formBuilder.group({
            sku: ["", [Validators.required]],
            quantity: [null, [Validators.required]],
          })
        ])
      });
    }
  }

  get productsFromArray(): FormArray {
    return this.formSupplierOrder.get('products') as FormArray;
  }

  async createSupplierOrder(vendor: string) {
    let params: string;
    let availability: any;
    let formGroup!: any;
    if (['bamboo', 'wupex'].includes(vendor)) {
      this.productsFromArray.controls.map(
        ele => {
          formGroup = ele;
        }
      )
      params = makeQueryParams({
        productId: vendor == 'bamboo' ? formGroup.value.ProductId : formGroup.value.sku,
        query: ' ',
      })
      availability = await firstValueFrom(
        this._productsService.vendorsSearch(params)
      )
    } else {
      params = makeQueryParams({
        productId: this.formSupplierOrder.get('productId')?.value,
        query: ' ',
      })
      availability = await firstValueFrom(
        this._productsService.vendorsSearch(params)
      )

    }
    if (availability.bestPrice?.product?.available) {
      if (vendor == 'bamboo') this.formSupplierOrder.value.AccountId = this.selectedAccount.id;
      this._productsService.createVendorOrder(this.formSupplierOrder.value, vendor).pipe(
        tap(
          res => {
            this._toastService.toastData.next({ severity: 'success', summary: 'Success', detail: `${vendor} order created` });
            this.formSupplierOrder.reset();
            this.GUIDChange = false;
            this.disableForm();
          }
        )
      ).subscribe(noop, err => {
        this._toastService.toastData.next({ severity: 'error', summary: 'Error', detail: err.error?.message });
        this.GUIDChange = false;
        this.disableForm();
      })
    } else {
      this.GUIDChange = false;
      this.disableForm();
      this._toastService.toastData.next({ severity: 'error', summary: 'Error', detail: 'Product Is Not Available' })
    }
  }

  disableForm() {
    this.formSupplierOrder.disable();
    this.productsFromArray.controls.map(group => {
      console.log('group: ', group);
      group.disable();
    })
  }

  enableForm() {
    this.formSupplierOrder.enable();
    this.productsFromArray.controls.map(group => {
      group.enable();
    })
    this.createSupplierOrderForm(this.suppliersTaping.bamboo ? 'bamboo' : this.suppliersTaping.likeCard ? 'likecard' : 'wupex');
    this.formSupplierOrder.get('productId')?.setValue(this.productId);

  }

  onPageChange(event: any) {
    let { page, rows, first } = event;
    page++;
    this.page = page;
    this.first = first;
    this.limit = rows;
    let vendor = { value: this.skuForm.get('supplier')?.value }
    this.onVendorSelect(vendor)
  }

  ngOnDestroy(): void {

  }


}
